import React from 'react'

const CertificateHelpBox = props => {
  return (
    <>
      <div className="modal-overlay">
        <div className="modal modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title text-center">
                도움말
              </div>
              <button
                type="button"
                className="icon-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={props.onClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-description tal">
                {props.text}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-dark-blue" onClick={props.onClose}>닫기</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CertificateHelpBox;